import React from "react";

import { PositionCategory } from "../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

import { FlyerDetailPageFormPositionCategoryPill } from "../flyer-detail-page-form-position-category-pill/flyer-detail-page-form-position-category-pill.component";

import { Categories } from "./flyer-detail-page-form-position-categories.styles";
import { FlyerDetailPageFormPositionCategoriesProps } from "./flyer-detail-page-form-position-categories.props";
import { PositionCategorySearch } from "./components/position-categories-search/position-categories-search.component";

export const FlyerDetailPageFormPositionCategories = (
  props: FlyerDetailPageFormPositionCategoriesProps
) => {
  const addCategory = (category: PositionCategory) => props.onAddCategory(category);
  const remove = (category: PositionCategory) => () =>
    props.permissions.canEdit && props.onRemoveCategory(category);

  return (
    <>
      <PositionCategorySearch disabled={!props.permissions.canEdit} onSelect={addCategory} />
      <Categories>
        {props.categories.map((category: PositionCategory, index) => (
          <FlyerDetailPageFormPositionCategoryPill
            key={index}
            canEdit={props.permissions.canEdit}
            onRemove={remove(category)}
          >
            {category.name}
          </FlyerDetailPageFormPositionCategoryPill>
        ))}
      </Categories>
    </>
  );
};
